import React from "react"

import { Layout } from "../components/layout"
import { useConfiguration } from "../hooks/useConfiguration";
import { resolvePath } from "../utils/resolvePath";
import { ErrorMessage } from "../components/errorMessage";

export const Error404 = () => {
   const configuration = useConfiguration();

  return (
    <Layout copyright={configuration?.copyright ?? ""}>
      <div className='error-page__content-404'>
        <img className='error-page__image' src={resolvePath("error_sheep.png")} />
        <ErrorMessage title='Error 404' message='Page not found.' />
      </div>
    </Layout>
  );
}